import React,{useState} from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

    const [open,setOpen] = useState(false)

  return (
    <div class="bg-red-600">
      <div class="lg:flex flex justify-between lg:p-3  text-white pl-8">
      <h1 class="lg:text-4xl text-3xl font-semibold  text-white font-serif" >Football Quiz</h1>
      <div className='relative lg:hidden flex justify-center items-center p-6 '>
       {
        !open ?  <i className='pi pi-bars text-3xl cursor-pointer' onClick={()=>setOpen(!open)}></i>
        :
        <i className='pi pi-times text-3xl cursor-pointer' onClick={()=>setOpen(!open)} ></i>
       }

       {
        open && 
        <>
        <div class="absolute top-16 right-10 items-center w-[15rem] bg-red-600">
      <ul class="flex flex-col gap-4 p-4">
        <Link to='/' class="hover:text-black text-lg text-white no-underline" onClick={()=>setOpen(false)}>Home</Link>
        <Link to='/football-quiz/play' class="hover:text-black text-lg text-white no-underline" onClick={()=>setOpen(false)}>How To Play</Link>
        <Link to='/football-quiz/terms' class="hover:text-black text-lg text-white  no-underline" onClick={()=>setOpen(false)}>Terms and Conditions</Link>
      </ul>
      </div>
        </>
       }
        
      </div>
      <div class="lg:flex hidden items-center pr-12">
      <ul class="flex gap-6 space-x-4 ">
        <Link to='/' class="hover:text-black text-lg text-white no-underline">Home</Link>
        <Link to='/football-quiz/play' class="hover:text-black text-lg text-white no-underline">How To Play</Link>
        <Link to='/football-quiz/terms' class="hover:text-black text-lg text-white  no-underline">Terms and Conditions</Link>
      </ul>
      </div>
      </div>
    </div>
  );
}

export default Header;
